import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { AppService } from '@base/app.service';
import { IErrorResponse } from '@interfaces';
import { ExceptionService } from './../exceptions.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-server-down',
  templateUrl: './server-down.component.html',
  styleUrls: ['./server-down.component.sass']
})
export class ServerDownComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  showSpinner = false;

  constructor(
    private snackBar: MatSnackBar,
    private mainService: AppService,
    private router: Router,
    private exceptionService: ExceptionService,
  ) { }

  ngOnInit() {
    localStorage.removeItem('token');
  }

  ngOnDestroy() {
    if (typeof this.subscription !== 'undefined') {
      this.subscription.unsubscribe();
    }
  }

  openSnackBar(message: string, action: string, duration: number = 4000): void {
    try {
      this.snackBar.open(message, action, {
        verticalPosition: 'top',
        horizontalPosition: 'right',
        duration: duration,
      });
    } catch (error) {
      console.log(error);
    }
  }

  redirectBack() {
    this.showSpinner = false;
    let targetUrl = localStorage.getItem('temp_url');
    targetUrl = (targetUrl !== null) ? targetUrl : '';
    this.router.navigate([targetUrl]);
    localStorage.removeItem('temp_url');
  }

  getToken() {
    const token = localStorage.getItem('token');
    // console.log(token);
  }

  reconnect() {
    this.showSpinner = true;

    this.subscription = this.mainService.pingToServer().subscribe(
      (response: Response) => {
        this.redirectBack();
      },
      (err: HttpErrorResponse) => {
        const error: IErrorResponse = this.exceptionService.errorHandling(err);
        if (err.status === 401) {
          localStorage.removeItem('token');
          this.redirectBack();
        } else if (err.status === 0) {
          this.showSpinner = false;
          this.openSnackBar(error.message, error.title);
        }
      }
    );
  }
}
